import React, { useCallback, useState } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { cn } from '@wwe-portal/ui/lib/lib';
import { DialogCloseButton } from '../../../components/dialog';

export interface MoreDescriptionProps {
  onClose?: () => void;
  detailsDescription: string;
  rewardList?: string[];
  isDark?: boolean;
  actionBtn: React.ReactNode;
}

const TABS = {
  Contents: 'contents',
  Description: 'description',
};

export default function MoreDescription({
  onClose,
  rewardList,
  detailsDescription,
  isDark,
  actionBtn,
}: Readonly<MoreDescriptionProps>) {
  const [selectedTab, setSelectedTab] = useState(TABS.Contents);
  const renderContents = useCallback(() => {
    if (selectedTab === TABS.Contents) {
      return (
        <div className="no-scrollbar flex flex-col overflow-y-scroll text-xs">
          {rewardList?.map((reward) => (
            <div className="flex items-center justify-start pb-3" key={reward}>
              <span className="bg-textColor2 font-poppins mr-4 h-2 w-2 min-w-[8px] rounded font-normal" />
              <span className="text-textColor2">{reward}</span>
            </div>
          ))}
        </div>
      );
    }
    return <div className="text-textColor2 text-xs">{detailsDescription}</div>;
  }, [detailsDescription, selectedTab, rewardList]);

  return (
    <div
      className="font-poppins absolute h-full w-full rounded-[10px] p-2"
      style={{
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        backgroundColor: isDark ? '#17181e94' : '#ecf1f8',
      }}
    >
      <div
        className="flex h-full flex-col justify-between rounded-[10px] px-5 pb-2 pt-5"
        style={{
          backgroundColor: isDark ? '#272b4a95' : '#fff',
        }}
      >
        <div className="flex w-full justify-between">
          <div className="flex h-6 text-xs font-semibold leading-[18px]">
            <ClickableDiv
              className={cn(
                'text-text400 border-b-[1px] border-transparent',
                selectedTab === TABS.Contents &&
                  'border-t-2 border-[#12EEB1] text-[#12EEB1]'
              )}
              onClick={() => setSelectedTab(TABS.Contents)}
              style={{
                borderBottom: selectedTab === TABS.Contents ? '1px solid' : '',
              }}
            >
              Contents
            </ClickableDiv>
            <ClickableDiv
              className={cn(
                'text-text400 ml-4 border-b-[1px] border-transparent',
                selectedTab === TABS.Description &&
                  'border-[#12EEB1] text-[#12EEB1]'
              )}
              onClick={() => setSelectedTab(TABS.Description)}
              style={{
                borderBottom:
                  selectedTab === TABS.Description ? '1px solid' : '',
              }}
            >
              Description
            </ClickableDiv>
          </div>
          <DialogCloseButton
            backgroundColor="transparent"
            className="relative top-1"
            noBackground
            onClose={onClose}
          />
        </div>
        <div className="no-scrollbar mb-10 h-full max-h-40 overflow-scroll">
          {renderContents()}
        </div>
        <div className="flex justify-center">{actionBtn}</div>
      </div>
    </div>
  );
}
